module.exports = __webpack_public_path__ + "static/img/hdw10.99a0b2de.jpg";